module.exports = __webpack_public_path__ + "static/media/rockWallSheetRight.38cd9f85.png";